/**
 * AdminInstallStatsRpcClient - AtomRpc integration for the admin install-stats
 * endpoint (`admin/installs/stats`).
 *
 * Drives the agent Overview tab's four stats panels (Resources, OpenClaw
 * memory, Workspace, Skills) from the latest `InstallStats` snapshot. Requires
 * admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { InstallStatsRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminInstallStatsRpcClient extends AtomRpc.Tag<AdminInstallStatsRpcClient>()(
  "AdminInstallStatsRpcClient",
  {
    group: InstallStatsRpcs,
    protocol: makeRpcClientLayer(InstallStatsRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
